import { render } from "./FormDigitalLead.vue?vue&type=template&id=197704bd&scoped=true"
import script from "./FormDigitalLead.vue?vue&type=script&lang=js"
export * from "./FormDigitalLead.vue?vue&type=script&lang=js"

import "./FormDigitalLead.vue?vue&type=style&index=0&id=197704bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197704bd"]])

export default __exports__